import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
import { up } from "~/features/app/screens";
import { useDeepDiveGallery } from "~/features/blocks/inventory/deep-dive-gallery/context";
import { DeepDiveGalleryBound } from "~/features/blocks/inventory/deep-dive-gallery/deep-dive-gallery-cursor/deep-dive-gallery-bound";
import { DeepDiveGalleryCursorButton } from "~/features/blocks/inventory/deep-dive-gallery/deep-dive-gallery-cursor/deep-dive-gallery-cursor-button";
import { Icon } from "~/features/ui/icon";
import { useMediaQuery } from "~/features/ui/use-media-query";
import CaretLeft from "~/public/icons/caret-left.svg";
import CaretRight from "~/public/icons/caret-right.svg";
export function DeepDiveGalleryCursor() {
  const {
    activeStepIndex,
    isVideoPlaying,
    controls,
    goPrev,
    goNext,
    renderGalleryCursor
  } = useDeepDiveGallery();
  const isLg = useMediaQuery(up("lg"));
  const isPrevDisabled = isVideoPlaying || activeStepIndex === 0;
  const isNextDisabled = isVideoPlaying || activeStepIndex === controls.length - 1;
  if (!isLg) {
    return null;
  }
  return <_StyledDiv>
      <_StyledDeepDiveGalleryBound cursorPositionOffset={-14} isHidden={isPrevDisabled || !renderGalleryCursor}>
        <_StyledDeepDiveGalleryCursorButton onClick={() => goPrev()}>
          <Icon icon={CaretLeft} />
          <span>Previous</span>
        </_StyledDeepDiveGalleryCursorButton>
      </_StyledDeepDiveGalleryBound>

      <_StyledDeepDiveGalleryBound2 cursorPositionOffset={-14} isHidden={isNextDisabled || !renderGalleryCursor}>
        <_StyledDeepDiveGalleryCursorButton2 onClick={() => goNext()}>
          <span>Next</span>
          <Icon icon={CaretRight} />
        </_StyledDeepDiveGalleryCursorButton2>
      </_StyledDeepDiveGalleryBound2>
    </_StyledDiv>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-k4fhm3-0"
})({
  "position": "absolute",
  "inset": "0",
  "height": "100%",
  "width": "100%",
  "overflow": "hidden"
});
var _StyledDeepDiveGalleryBound = _styled2(DeepDiveGalleryBound).withConfig({
  componentId: "sc-sf-k4fhm3-1"
})({
  "position": "absolute",
  "left": "0",
  "top": "0",
  "height": "100%",
  "width": "40%"
});
var _StyledDeepDiveGalleryCursorButton = _styled3(DeepDiveGalleryCursorButton).withConfig({
  componentId: "sc-sf-k4fhm3-2"
})({
  "paddingLeft": "0.8rem",
  "paddingRight": "1.6rem"
});
var _StyledDeepDiveGalleryBound2 = _styled4(DeepDiveGalleryBound).withConfig({
  componentId: "sc-sf-k4fhm3-3"
})({
  "position": "absolute",
  "right": "0",
  "top": "0",
  "height": "100%",
  "width": "40%"
});
var _StyledDeepDiveGalleryCursorButton2 = /*#__PURE__*/_styled5(DeepDiveGalleryCursorButton).withConfig({
  displayName: "deep-dive-gallery-cursor___StyledDeepDiveGalleryCursorButton2",
  componentId: "sc-krbqg-0"
})({
  "paddingLeft": "1.6rem",
  "paddingRight": "0.8rem"
});